import styled from 'styled-components';

export const StyledMapWrapper = styled.div`
  /* NOTE: hide default 'x' button for closing InfoWindow, because it is implemented as tooltip */
  .gm-ui-hover-effect {
    display: none !important;
  }

  /* NOTE: add InfoWindow style according to design */
  .gm-style-iw.gm-style-iw-c {
    padding: 0 !important;
    background: #404040;
  }

  .gm-style-iw-d {
    overflow: auto !important;
    color: white !important;
    padding: 12px;
    padding-top: 0;
    background: #404040;
  }

  .gm-style-iw-tc {
    ::after {
      background: #404040;
    }
  }
`;
